export const customerFragment = /* GraphQL */ `
  fragment CustomerFragment on Customer {
    id
    userID
    organizationID
    createdAt
    firstName
    lastName
    email
    type
    companyName
    SIRET
    VAT
    notes
    phone
    address
    zipcode
    city
    country
  }
`
